// extracted by mini-css-extract-plugin
module.exports = {"customModal":"_2ZLVZASZauJmycG9iCG19K","title-modal":"_2Z4kIgNQ8tzcV7vRQgELgS","slideshow_content_":"_1iyqV_oj5bKl5AspeqVLBi"};